const getSystemConfig = async () => {
    return fetch("/config/dataharbor_config.json")
        .then((response) => response.json())
        .then((_data) => {
            return _data;
        })
        .catch((error) => {
            console.error(error);
        });
};

const config = await getSystemConfig();

export const baseUrl =
    (process.env.NODE_ENV === "development"
        ? config.dev_url
        : config.frontend_and_backend_at_same_server
            ? window.location.origin + config.prod_url
            : config.extrenal_prod_url);
